
import React, { FC, useRef, useEffect, useState } from 'react';
import { Box, Heading as RadixHeading, Flex } from '@radix-ui/themes';
import TypeIt from 'typeit-react';
import './Statement.css';

interface StatementProps { }

const Statement: FC<StatementProps> = () => {
  const statementRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    const currentStatementRef = statementRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
          setKey(prev => prev + 1);
        } else if (!entry.isIntersecting && isVisible) {
          setIsVisible(false);
        }
      },
      { threshold: 0.1 }
    );

    if (currentStatementRef) {
      observer.observe(currentStatementRef);
    }

    return () => {
      if (currentStatementRef) {
        observer.unobserve(currentStatementRef);
      }
    };
  }, [isVisible]);

  return (
    <Box className="Statement" data-testid="Statement" ref={statementRef}>
      <Flex gap="4">
        <RadixHeading as="h1" className='Statement-Cursor'>
          <strong>
            <TypeIt
              options={{
                speed: 30,
                waitUntilVisible: true,
                cursorChar: "_",
              }}
            >
            </TypeIt>
          </strong>
        </RadixHeading>
        <RadixHeading as="h1" className="Statement-Text">
          {isVisible ? (
            <TypeIt
              key={key}
              getBeforeInit={(instance) => {
                return instance
                  .type("driving technology forward — with scale.")
                  .pause(500)
                  .move(-6)
                  .type("intelligence, and ", { delay: 300 })
                  .pause(300)
                  .move(-18)
                  .type("automation, ", { delay: 200 })
                  .pause(500)
                  .move(-12)
                  .type("speed, ", { delay: 200 })
                  .move(null, { to: "END" });
              }}
              options={{
                speed: 50,
                loop: false,
              }}
            />
          ) : (
            <span style={{ opacity: 0 }}>
              driving technology forward — with speed, automation, intelligence, and scale.
            </span>
          )}
        </RadixHeading>
      </Flex>
    </Box >
  );
};

export default Statement;
